import {Component, EventEmitter, Input, Output} from '@angular/core';

import {LinkComponent} from "../link/link.component";

@Component({
    selector: 'app-warning',
    imports: [
        LinkComponent
    ],
    templateUrl: './warning.component.html',
    styleUrl: './warning.component.scss'
})
export class WarningComponent {
  @Input() public message: string = '';
  @Input() public linkText: string = '';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public  click: EventEmitter<void> = new EventEmitter<void>();

  public selected(event: Event): void {
    event.stopPropagation();
    this.click.emit();
  }
}
